<template>
  <div class="row border-bottom flex-nowrap p-2 h-100 mb-0">
    <employeeInfo :engagement="engagement" />

    <employeeEngagementIndex :engagement="engagement" />

    <engagementScale :engagement="engagement" />

    <!-- <employeePerformance :engagement="engagement" /> -->

    <employeeEvaluation :engagement="engagement" />

    <div class="col">
      <div class="row h-50 w-100 p-3 border-bottom align-items-center">
        <router-link :to="'/employeeindepth/' + user.uid"
          >In-depth overview <i class="fas fa-chevron-right"></i
        ></router-link>
      </div>
      <div class="row h-50 w-100 p-3 align-items-center">
        <router-link :to="'/employeeprofile/' + user.uid"
          >Employee profile <i class="fas fa-chevron-right"></i
        ></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import doughnutChart from "@/components/engagement/charts/percentageDoughnutChart.js";
import employeeInfo from "@/components/engagement/overview/EmployeeInfo.vue";
import employeeEngagementIndex from "@/components/engagement/overview/EmployeeEngagementIndex.vue";
import engagementScale from "@/components/engagement/overview/EngagementScale.vue";
import employeePerformance from "@/components/engagement/overview/EmployeePerformance.vue";
import employeeEvaluation from "@/components/engagement/overview/EmployeeEvaluation.vue";
import { mixins } from "vue-chartjs";

import { evaluationMethods } from "@/mixins/engagement/evaluationMethods.js";
import { engagementScaleMethods } from "@/mixins/engagement/engagementScaleMethods.js";
import { employeeEngagementMethods } from "@/mixins/engagement/employeeEngagementMethods.js";
import { adjustColor } from "@/mixins/engagement/adjustChartColor.js";

export default {
  mixins: [
    mixins.reactiveProp,
    evaluationMethods,
    engagementScaleMethods,
    employeeEngagementMethods,
    adjustColor,
  ],
  props: ["user", "chartData"],
  components: {
    doughnutChart,
    employeeInfo,
    employeeEngagementIndex,
    engagementScale,
    employeePerformance,
    employeeEvaluation,
  },
  data() {
    return {
      engagement: {
        employeeUID: null,
        employeeName: null,
        employeeEngagement: null,
        employeeEngagementChart: null,
        uwes: null,
        uwesChart: null,
        performance: null,
        performanceValue: null,
        evaluation: null,
        evaluationChart: null,
        chartOptions: {
          responsive: true,
          maintainAspectRatio: true,
          cutoutPercentage: 60,
          legend: {
            display: false,
          },
          tooltips: false,
          plugins: {
            datalabels: {
              display: function (ctx) {
                return false;
              },
            },
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters("uwes", ["getUwes"]),
    ...mapGetters("evaluation", ["getEvaluation", "getEvaluationByUserId"]),
    ...mapGetters("users", ["getClaims"]),
  },
  
  mounted() {
    this.fillData();
  },
  methods: {
    async setUwesData() {
      const where = [
        ["userId", "==", this.user.uid],
        ["companyId", "==", this.getClaims.companyId],
      ];
      const orderBy = ["created_at", "desc"];
      await this.$store
        .dispatch("uwes/fetchAndAdd", { clauses: { where, orderBy, limit: 1 } })
        .catch((e) => {});
      let uwesData = await this.getUwes(this.user.uid);

      if (uwesData && uwesData !== undefined) {
        this.engagement.uwes = await this.getEngagementScale(uwesData);
        this.engagement.uwesChart = await this.getChartDataEngagamentScale(
          this.engagement.uwes
        );
      }
      this.updateEEI();
      return;
    },

    async setEvaluationData() {
      const where = [
        ["evaluatee.uid", "==", this.user.uid],
        ["companyId", "==", this.getClaims.companyId],
      ];
      const orderBy = ["created_at", "desc"];
      await this.$store
        .dispatch("evaluation/fetchAndAdd", { clauses: { where, orderBy } })
        .catch((e) => {});
      let evaluationData = await this.getEvaluationByUserId(this.user.uid);

      if (evaluationData && evaluationData !== undefined) {
        this.engagement.evaluation = await this.getEvaluationScore(
          evaluationData
        );
        if (this.engagement.evaluation !== "inProgress") {
          this.engagement.evaluationChart =
            await this.getChartDataEvaluationScale(this.engagement.evaluation);
            this.updateEEI();
        }
      }
      
      return;
    },

    async updateEEI() {
      if (this.engagement.uwes && this.engagement.evaluation) {
        this.engagement.employeeEngagement = this.getEmployeeEngagementIndicationScore(
          this.engagement.uwes,
          this.engagement.evaluation
        );
        // console.log(this.engagement.employeeEngagement);
        this.engagement.employeeEngagementChart = this.getChartDataEEI(
          this.engagement.employeeEngagement
        );
        // console.log(this.engagement.employeeEngagementChart);
      }
    },

    

    fillData() {
      this.engagement.employeeUID = this.user.uid;
      this.engagement.employeeName = this.user.displayName;

      //performance values
      this.engagement.performanceValue = 50;
      this.engagement.performance = {
        datasets: [
          {
            data: [
              this.engagement.performanceValue,
              100 - this.engagement.performanceValue,
            ],
            backgroundColor: [
              this.adjustColor(this.engagement.performanceValue),
            ],
            borderWidth: 0,
          },
        ],
        labels: ["Employee Engagement Index"],
      };
    },
  },

  async created() {
    let uwesData = await this.getUwes(this.user.uid);
    if (!uwesData) {
      await this.setUwesData();
    } else {
      this.engagement.uwes = await this.getEngagementScale(uwesData);
      this.engagement.uwesChart = await this.getChartDataEngagamentScale(
        this.engagement.uwes
      );
    }

    let evaluationData = await this.getEvaluation(this.user.uid);
    if (!evaluationData) {
      await this.setEvaluationData();
    } else {
      this.engagement.evaluation = await this.getEvaluationScore(
        evaluationData
      );
      // this.engagement.evaluationChart = await this.getChartDataEngagamentScale(
      //   this.engagement.evaluation
      // );
    }
    
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewBar.scss";
</style>